import { Component, OnInit } from '@angular/core';

interface BudgetItem {
  name: string;
  category: string;
  amount: number;
}

@Component({
  selector: 'app-budget-helper',
  templateUrl: './budget-helper.component.html',
  styleUrls: ['./budget-helper.component.css']
})
export class BudgetHelperComponent implements OnInit {
  budgetItems: BudgetItem[] = [];
  newBudgetItem: BudgetItem = { name: '', category: '', amount: 0 };
  supermarketItems: BudgetItem[] = [
    { name: 'Arroz', category: 'Alimentos', amount: 1.2 },
    { name: 'Leche', category: 'Alimentos', amount: 0.8 },
    { name: 'Huevos', category: 'Alimentos', amount: 1.5 },
    // Add more items as needed
  ];
  cart: BudgetItem[] = [];
  totalCartAmount: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

  addBudgetItem() {
    if (this.newBudgetItem.name && this.newBudgetItem.category && this.newBudgetItem.amount > 0) {
      this.budgetItems.push({ ...this.newBudgetItem });
      this.newBudgetItem = { name: '', category: '', amount: 0 };
    }
  }

  addToCart(item: BudgetItem) {
    this.cart.push(item);
    this.calculateCartTotal();
  }

  removeFromCart(index: number) {
    this.cart.splice(index, 1);
    this.calculateCartTotal();
  }

  calculateCartTotal() {
    this.totalCartAmount = this.cart.reduce((total, item) => total + item.amount, 0);
  }

  addCartToBudget() {
    this.budgetItems.push(...this.cart);
    this.cart = [];
    this.totalCartAmount = 0;
  }

  removeBudgetItem(index: number) {
    this.budgetItems.splice(index, 1);
  }
}
